import Navbar from "@/components/layout/Navbar";
import Hero from "@/components/home/Hero";
import Banner from "@/components/home/Banner";
import Features from "@/components/home/Features";
import Enterprise from "@/components/home/Enterprise";
import Testimonials from "@/components/home/Testimonial";
import Subscription from "@/components/home/Subscription";
import Faq from "@/components/home/Faq";
import Cta from "@/components/home/Cta";
import Footer from "@/components/layout/Footer";
import Industries from "@/components/home/Industries";
import Resources from "@/components/home/Resources";
// import Solutions from "@/components/home/Solution";

const Index = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="flex-grow">
        <Hero />
        <Banner />
        {/* <Solutions /> */}
        <Features />
        <Subscription />
        <Enterprise />
        <Industries />
        <Resources />
        {/* <Testimonials />
        <Faq /> */}
        {/* <Cta /> */}
      </div>
      <Footer />
    </div>
  );
};

export default Index;
